import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'

export const getMaintenance = async() => {
    try {
        const response = await axios.get(`${url}/maintenance`, {
            headers: HeadersWithCredentials(),
        })
        return {
            error: false,
            data: response.data.data,
        }
    } catch (error) {
        console.error('Error fetching maintenance:', error)
        return {
            error: true,
            data: {
                isActive: false,
                message: '',
                estimatedEndTime: null,
            },
        }
    }
}
